module.exports = __webpack_public_path__ + "img/icon-3d_print.12b5f9f1.svg";